import styles from './index.module.scss';
import createContainer from '../ContainerFactory';

export default createContainer(styles.borderedCardContainer);
